import { PART_CODE_MIN_LENGTH } from 'utils/constants';

/* Every way into the parts listing narrows it to something: a model (reached
   through its maker), a brand, a category, or a part code. With none of them
   the screen asks the API for the listing with no filter at all, which answers
   with every part the client can see - thousands of rows nobody asked for, and
   before the API was scoped properly, rows they were never assigned at all.

   The way in was the clear icon on a code search: it drops `part_code` and
   `type`, and a client who arrived straight from the code search screen has
   nothing else in the URL, so the listing refetched unfiltered. Typing /parts
   by hand, or going back to it, reaches the same place. */
export const SCOPE_KEYS = ['maker_id', 'model_id', 'brand_id', 'category_id'];

/* The API answers a code shorter than PART_CODE_MIN_LENGTH with a 422, and the
   search box refuses one before it is sent. A code typed into the URL went
   through neither, so the screen made the round trip only to render the error.
   The rule belongs to the search rather than to the input, so it is applied
   here too and the three agree.

   `type=code` on its own is not a scope: it is the layout the code search puts
   the listing in, and the code is what narrows the rows. */
const hasUsableCode = (query) =>
  query.type === 'code' && String(query.part_code ?? '').trim().length >= PART_CODE_MIN_LENGTH;

/* Takes a query that has been through utils/query#parseQuery, which is how the
   screen reads the URL: a key that carries nothing is gone by the time this
   sees it, rather than being present and holding the word `undefined`. */
export const isScoped = (query = {}) => SCOPE_KEYS.some((key) => Boolean(query[key])) || hasUsableCode(query);

export default isScoped;
